import { Pipe, PipeTransform } from '@angular/core';
/*
 * convert empty value to -
 * Takes one value argument.
 * Usage:
 *   value | emptyValue
 * Example:
 *   {{ undefined | emptyValue }}
 *   formats to: -
 */
@Pipe({
    name: 'emptyValue',
    pure: true
})
export class EmptyValuePipe implements PipeTransform {
  transform(value: unknown, isTitle = false): string {
    const isValueDefined = value !== null && value !== undefined;

    if (isValueDefined) {
      return String(value);
    } else {
      return isTitle ? 'Sem Valor Definido' : '';
    }
  }
}
